import { render, staticRenderFns } from "./BanGroupMember.vue?vue&type=template&id=66aaa376&scoped=true"
import script from "./BanGroupMember.vue?vue&type=script&lang=js"
export * from "./BanGroupMember.vue?vue&type=script&lang=js"
import style0 from "./BanGroupMember.vue?vue&type=style&index=0&id=66aaa376&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aaa376",
  null
  
)

export default component.exports